import PropTypes from "prop-types";
import UpSellCarouselSkeleton from "./UpSellCarouselSkeleton";
import UpSellCarousel from "./UpSellCarousel";
import styles from "./UpSellCarouselContainer.css";
import { useSearchCategory } from "./useSearchCategory";
import {
  CAROUSEL_PRODUCT_REQUEST_LIMIT,
  CAROUSEL_ID,
  MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL
} from "./constants";
import { withTranslation } from "../translation";

const UpSellCarouselContainer = ({
  carouselCatId,
  formatTranslation,
  ...rest
}) => {
  const queryParams = {
    limit: CAROUSEL_PRODUCT_REQUEST_LIMIT,
    excludeFacets: true
  };

  const { isError, isLoading, products } = useSearchCategory({
    cid: carouselCatId,
    params: queryParams
  });

  if (products?.length < MINIMUM_SEARCH_RESULTS_FOR_CAROUSEL) return null;

  return (
    <section
      id={CAROUSEL_ID}
      className={styles.container}
      aria-label={formatTranslation("accessibility_plp_carousel_generic_title")}
    >
      {isError || isLoading ? (
        <UpSellCarouselSkeleton isFrozen={isError} />
      ) : (
        <UpSellCarousel
          products={products}
          carouselCatId={carouselCatId}
          {...rest}
        />
      )}
    </section>
  );
};

UpSellCarouselContainer.prototype;

UpSellCarouselContainer.propTypes = {
  carouselCatId: PropTypes.number.isRequired,
  formatTranslation: PropTypes.func.isRequired
};

export default withTranslation(UpSellCarouselContainer);
